export const EVENT_CARD_UPDATE = 'card.update'
